import axios from '../axios'

// クイズ更新（questions を含めると設問を全置換）
const putQuizApi = async (quizId, payload) => {
  return await axios.put(`api/lms/quizzes/${quizId}`, payload)
}

export default putQuizApi
